// @flow

import * as React from 'react';

import Constants from '../Constants';

export const Weather = (props: { weather: number }) => {
  if (props.weather === Constants.WEATHER_RAINY) {
    return <div className="weather weather-rain" />;
  }
  return <div className="weather" />;
};
